import CircleAnimation from 'apps/atoms/CircleAnimation';
import EmptyDownloadHistory from 'apps/teacher/components/printable_worksheets/empty-download-history';
import PrintableWorksheetsEvents from 'printableWorksheets/events';
import { PRINTABLE_WORKSHEET_SCREENS, usePrintableWorksheetsState } from 'printableWorksheets/state';
import React, { useEffect, useState } from 'react'
import { WorksheetCard } from '../worksheetsView/worksheetCard/worksheetCard';
import BackIcon from './back-icon.svg'

interface IDownloadedScreenProps {
  hideHeader?: boolean;
}


const DownloadedScreen = ({hideHeader = false}: IDownloadedScreenProps) => {

  const { downloadedWorksheets, activeGrade, setActiveScreen, getDownloadedWorksheets} = usePrintableWorksheetsState();
  const [selectedDays, setSelectedDays] = useState('7');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleChange = (e: any) => {
    setSelectedDays(e.target.value);
  }

  const goBack = () => {
    setActiveScreen(PRINTABLE_WORKSHEET_SCREENS.DEFAULT)
  }

  const initDownloadedWorksheets = async (selectedDays: string) => {
    setIsLoading(true);
    await getDownloadedWorksheets(selectedDays);
    setIsLoading(false);
  }

  useEffect(() => {
    selectedDays && initDownloadedWorksheets(selectedDays);
  }, [selectedDays]);

  useEffect(() => {
    PrintableWorksheetsEvents.viewedDownloadHistoryWorksheetPage({
      worksheetGrade: activeGrade
    })
  }, [])

  const noOfDays = [
    {
      text: "Last 7 days",
      value: "7",
    },
    {
      text: "Last 30 days",
      value: "30"
    },
    {
      text: "All time",
      value: "365"
    },
  ];

  return (
    <div className='downloaded-worksheets'>
      {!hideHeader ? (
        <div className="downloaded-worksheets__header">
          <div className="left">
            <div className="go-back" onClick={() => goBack()}>
              <BackIcon />
            </div>
            <div className="title">Downloaded Worksheets</div>
          </div>
          {!isLoading && (
            <div className="right">
            {
              noOfDays.map((ele) => {
                return (
                  <li className={"change-days" + ((selectedDays === ele.value) ? " highlight" : "")} key={ele.value}>
                    <input
                      type="radio"
                      name={ele.text}
                      value={ele.value}
                      checked={selectedDays === ele.value}
                      onChange={handleChange}>
                    </input>
                    {ele.text}
                  </li>
                )
              }
              )
            }
            </div>
          )}
        </div>
      ) : null}
      {isLoading ? (
        <div className="downloaded-worksheets__loading-container">
          <CircleAnimation />
        </div>
      ) : (
        <div className="downloaded-worksheets__list">
        {downloadedWorksheets?.length > 0 ? downloadedWorksheets.map((worksheet: any) => {
          return <React.Fragment key={worksheet.id}>
            <WorksheetCard 
              card={worksheet}
            />
          </React.Fragment>
        }) : (
          <div className="empty-container">
            <EmptyDownloadHistory onGoToDownloadWorksheets={goBack} />
          </div>
        )}
      </div>
      )}
    </div>
  );
}

export default DownloadedScreen